
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M16 15H8c-.6 0-1-.4-1-1s.4-1 1-1h8c.6 0 1 .4 1 1s-.4 1-1 1zM16 19H8c-.6 0-1-.4-1-1s.4-1 1-1h8c.6 0 1 .4 1 1s-.4 1-1 1z"}}),_c('path',{attrs:{"d":"M17.7 23H6.2C4.4 23 3 21.7 3 20.1V3.9C3 2.2 4.3 1 6.2 1h11.7C19.6 1 21 2.3 21 3.9v16.3c-.2 1.7-1.5 2.8-3.3 2.8zM6.2 3c-.6 0-1.2.2-1.2.9v16.2c0 .6.6.9 1.2.9h11.5c.7 0 1.3-.4 1.3-.9V3.9c0-.5-.6-.9-1.1-.9H6.2z"}}),_c('path',{attrs:{"d":"M16 11H8c-.6 0-1-.4-1-1s.4-1 1-1h8c.6 0 1 .4 1 1s-.4 1-1 1zM14 7h-4c-.6 0-1-.4-1-1s.4-1 1-1h4c.6 0 1 .4 1 1s-.4 1-1 1z"}})])
      }
    
      }
    